<template>
	<div class="barcode-scanner row">
		<div class="col-12">
			<span>{{ $t('Barcode auf Flaschenhals scannen:') }}</span>
			<!--			<barcode-scanner-camera @serial="foundBarCode"></barcode-scanner-camera>-->
			<div ref="cameraPlaceholder" class="position-relative">
				<button @click="toggleFlashLight"
				        class="position-absolute btn btn-primary"
				        style="bottom: 100%; right: 0;">
					<i class="fas fa-lightbulb"></i></button>
				<img class="img-fluid" src="img/dummy.gif"
				     alt="camera" @loadeddata="emitHeight">
			</div>
		</div>
		<div class="col-12 text-center">
			<i class="fa fa-arrow-down text-medium-gray"></i>
		</div>
		<div class="col-12" :class="{'has-focus': hasFocus}">
			<data-input
				v-model="bottle_id"

				:placeholder="$t('Flaschennummer')"

				@focusin="stopCamera"
				@focusout="startCamera"
			>
				<template v-slot:onFocus>

					<button class="on-focus-btn" @click="emitSerial">+</button>

				</template>
			</data-input>
			<span class="small">{{ $t('Flaschennummern können auch direkt in das Textfeld eingegeben werden') }}</span>

		</div>
	</div>
</template>

<script>
import DataInput from "./DataInput";
import emitHeight from "../mixins/emitHeight";
import BarcodeScannerCamera from "./BarcodeScannerCamera";

export default {
	name: "BarcodeScanner",
	components: {BarcodeScannerCamera, DataInput},
	mixins: [emitHeight],
	data() {
		return {
			bottle_id: "",
			hasFocus: false,
			torch: false,
		}
	},
	mounted() {
		window.setTimeout(this.startCamera, 500)
	},
	beforeDestroy() {
		this.stopCamera()
	},
	methods: {
		toggleFlashLight() {
			if (this.torch) {
				window.CameraPreview.setFlashMode(window.CameraPreview.FLASH_MODE.OFF);
				this.torch = false;
			} else {
				window.CameraPreview.setFlashMode(window.CameraPreview.FLASH_MODE.TORCH);
				this.torch = true;
			}
		},
		getAbsoluteOffset(el) {
			let _x = 0;
			let _y = 0;
			while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
				_x += el.offsetLeft - el.scrollLeft;
				_y += el.offsetTop - el.scrollTop;
				el = el.offsetParent;
			}
			return {top: _y, left: _x};
		},
		startCamera() {
			// return;

			this.hasFocus = false;
			let cameraOffset = this.getAbsoluteOffset(this.$refs.cameraPlaceholder);
			console.log(cameraOffset);
			if (window.CameraPreview && typeof window.CameraPreview.startCamera === "function") {
				window.CameraPreview.startCamera({
					x: cameraOffset.left,
					y: cameraOffset.top,
					width: window.screen.width - (cameraOffset.left * 2),
					height: (window.screen.width - (cameraOffset.left * 2)) / 1.5,
					camera: window.CameraPreview.CAMERA_DIRECTION.BACK,
					tapPhoto: false,
					tapFocus: true,
					previewDrag: false,
					toBack: false,
					metaDataCallback: 'cordova.fireDocumentEvent("found-barcode-data", {"data": "%@"});',
					metaDataType: "Code128",
				}, (result) => {
					document.addEventListener('found-barcode-data', this.foundBarCode)
				}, error => this.cdvAlert('Error', error));
			} else {
				console.log('CameraPreview options => ', {
					x: cameraOffset.left,
					y: cameraOffset.top,
					width: window.screen.width - (cameraOffset.left * 2),
					height: this.$refs.cameraPlaceholder.clientHeight,
				})
			}

		},
		stopCamera() {
			// return;

			this.hasFocus = true;
			if (window.CameraPreview && typeof window.CameraPreview.stopCamera === "function") {
				window.CameraPreview.stopCamera();
				document.removeEventListener('found-barcode-data', this.foundBarCode)
			}
		},
		foundBarCode(e) {
			console.log('received foundBarCode event => ', e, e.data);
			let bottle_id = e.data || e.detail || e;
			if (this.bottle_id !== bottle_id) {
				this.bottle_id = bottle_id;
				this.emitSerial(bottle_id);
			}
		},
		emitSerial(bottle_id) {
			if (!bottle_id) {
				bottle_id = this.bottle_id
			}

			if (this.bottle_id.trim()) {
				this.$emit('change', this.bottle_id);
				this.bottle_id = "";
			}
		}
	}
}
</script>

<style scoped>

</style>
